import { useParams } from "react-router-dom";
import { PageHeader } from "@/components/common/PageHeader";
import { Loader } from "@/components/common/Loader";
import { usePublicContent } from "@/lib/useContent";

const FALLBACK = {
  privacy: { title: ["PRIVACY ", "POLICY"] },
  terms: { title: ["TERMS & ", "CONDITIONS"] },
  refund: { title: ["REFUND ", "POLICY"] },
  cancellation: { title: ["CANCELLATION ", "POLICY"] },
  "membership-commitment": { title: ["MEMBERSHIP ", "COMMITMENT"] },
  "liability-waiver": { title: ["LIABILITY ", "WAIVER"] },
  "health-intake": { title: ["HEALTH ", "HISTORY"] },
  "photo-video-release": { title: ["PHOTO / VIDEO ", "RELEASE"] },
  waivers: { title: ["WAIVERS & ", "FORMS"] },
};

const splitTitle = (t) => {
  if (!t) return ["", ""];
  const parts = t.split(" ");
  if (parts.length === 1) return [t, ""];
  const right = parts.pop();
  return [parts.join(" ") + " ", right];
};

export default function Policy() {
  const { slug } = useParams();
  const { data, loading } = usePublicContent("policies");
  const policy = data.find((p) => p.slug === slug);
  const fb = FALLBACK[slug] || { title: ["", ""] };
  const [left, right] = policy ? splitTitle(policy.title) : fb.title;
  const paragraphs = policy ? (policy.body || "").split(/\n\s*\n/) : [];

  return (
    <div data-testid={`policy-page-${slug}`}>
      <PageHeader eyebrow="Legal" titleLeft={left} titleRight={right} image="https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=1600&q=70&auto=format&fit=crop" />
      <section className="bg-background py-16 sm:py-20">
        <div className="mx-auto w-full max-w-3xl px-4 sm:px-6 space-y-5">
          {(() => {
            if (loading) return <Loader />;
            if (!policy) return <p className="text-muted-foreground">This policy is being updated. Please check back soon or contact us.</p>;
            return (
              <>
                {paragraphs.map((para) => <p key={para.slice(0, 48)} className="whitespace-pre-wrap text-muted-foreground leading-relaxed">{para}</p>)}
                <p className="text-xs text-muted-foreground">Last updated {new Date(policy.updated_at || Date.now()).toLocaleDateString("en-US", { month: "long", year: "numeric" })}.</p>
              </>
            );
          })()}
        </div>
      </section>
    </div>
  );
}
